import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { LanguageProvider } from "@/lib/i18n";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import ClubPage from "@/pages/ClubPage";
import ScenarioBuilder from "@/pages/ScenarioBuilder";
import ScenarioDetail from "@/pages/ScenarioDetail";
import ComparisonPage from "@/pages/ComparisonPage";
import InvitesPage from "@/pages/InvitesPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import TeamInvitePage from "@/pages/TeamInvitePage";
import PaymentStatusPage from "@/pages/PaymentStatusPage";
import PricingPage from "@/pages/PricingPage";
import AccountPage from "@/pages/AccountPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import ConfirmEmailPage from "@/pages/ConfirmEmailPage";
import AdminPage from "@/pages/AdminPage";
import ManualPage from "@/pages/ManualPage";
import CookieNotice from "@/components/CookieNotice";

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/join-the-team" element={<RegisterPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/clubs/:clubId" element={<ProtectedRoute><ClubPage /></ProtectedRoute>} />
            <Route path="/clubs/:clubId/scenarios/new" element={<ProtectedRoute><ScenarioBuilder /></ProtectedRoute>} />
            <Route path="/clubs/:clubId/scenarios/:scenarioId" element={<ProtectedRoute><ScenarioDetail /></ProtectedRoute>} />
            <Route path="/clubs/:clubId/scenarios/:scenarioId/edit" element={<ProtectedRoute><ScenarioBuilder /></ProtectedRoute>} />
            <Route path="/clubs/:clubId/compare" element={<ProtectedRoute><ComparisonPage /></ProtectedRoute>} />
            <Route path="/uitnodigingen" element={<ProtectedRoute><InvitesPage /></ProtectedRoute>} />
            <Route path="/invites" element={<Navigate to="/uitnodigingen" replace />} />
            <Route path="/beheer" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
            <Route path="/admin" element={<Navigate to="/beheer" replace />} />
            <Route path="/handleiding" element={<ProtectedRoute><ManualPage /></ProtectedRoute>} />
            <Route path="/team-invite" element={<TeamInvitePage />} />
            <Route path="/prijzen" element={<ProtectedRoute><PricingPage /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
            <Route path="/account/confirm-email" element={<ConfirmEmailPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/voorwaarden" element={<TermsPage />} />
            <Route path="/payment-status" element={<ProtectedRoute><PaymentStatusPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieNotice />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
